import {AccountId} from "platformed-client/types";
import {platformedClient} from "..";

export async function get(accountId: AccountId) {
  return await platformedClient.externalRequest("get", `/external_api/accounts/{account_id}`, {
    path: {account_id: accountId},
  });
}

export async function getBySlug(accountSlug: string) {
  return await platformedClient.externalRequest("get", `/external_api/accounts_by_slug/{account_slug}`, {
    path: {account_slug: accountSlug},
  });
}
